import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IRefundedTransactionsApiService } from './refunded-transactions-api.interface';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportRefundedTransactionsQueryDto } from './dtos/export-refunded-transactions.query.dto';
import { FindRefundedTransactionsQueryDto } from './dtos/find-refunded-transactions.query.dto';
import { FindRefundedTransactionsResponseDto } from './dtos/find-refunded-transactions.response.dto';

@Injectable({
  providedIn: 'root',
})
export class RefundedTransactionsApiService
  implements IRefundedTransactionsApiService
{
  private readonly ENDPOINT = 'refunded-transactions';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findRefundedTransactions(
    query: FindRefundedTransactionsQueryDto
  ): Promise<FindRefundedTransactionsResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindRefundedTransactionsResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportRefundedTransactions(
    query: ExportRefundedTransactionsQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
